import React, { Component } from 'react';
import axios from 'axios';
import {config } from '../config';
import Phases from '../components/Phases';
import UserData from '../components/UserData';
import Regulations from '../components/Regulations';
import ItemPicker from '../components/ItemPicker';
import ItemRegistration from '../components/ItemRegistration';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SuccessfulReg from '../components/SuccessfulReg';
import { login, getUserId, isUserLoggedIn } from '../service/UserService';

class Registration extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      actPhase: 1,
      userData: null,
      regulationsApproved: false,
      pickedItem: null,
      itemRegistrationData: null,
      showToast: false,
      toastMsg: ''
     }
  }

  componentDidMount(){
    //console.log("history:", this.props.history);
    //console.log("isUserLoggedIn:", isUserLoggedIn());
    const storedValue = localStorage.getItem('kwizda3');
    if(storedValue){
      let prevState = JSON.parse(storedValue)
      //console.log("existing data", prevState);
      this.setState({...prevState});
    }
  }

  componentDidUpdate(){
    localStorage.setItem('kwizda3', JSON.stringify(this.state));
  }
  
  handleBackClick2 = () => {
    //console.log("this.state", this.state);
    this.setState({ regulationsApproved: false, actPhase: 1});
  }

  handleBackClick3 = () => {
    //console.log("this.state", this.state);
    this.setState({actPhase: 2});
  }

  handleBackClick4 = () => {
    //console.log("this.state", this.state);
    this.setState({pickedItem: null, actPhase: 3});
  }

  handleSubmitClick = (values) => {
    //console.log("this.state", this.state);
    this.setState({userData: values, actPhase: 2});
  }
  handleSubmitClick2 = () => {
    //console.log("this.state", this.state);
    this.setState({regulationsApproved: true, actPhase: 3});
  }
  handleSubmitClick3 = (pickedItem) => {
    //console.log("pickedItem:", pickedItem)
    //console.log("this.state", this.state);
    this.setState({pickedItem: pickedItem, actPhase: 4});
  }

  handleSubmitClick4 = (itemRegistrationData) => {
    this.setState({itemRegistrationData: itemRegistrationData}, () =>{
      //console.log("this.state", this.state);
      this.handleSubmitClickFinal();
    });
  }

  handleSubmitClickFinal = () => {
    if(isUserLoggedIn()){
      this.setState({itemRegistrationData: {...this.state.itemRegistrationData, user_id: getUserId()}},
        ()=>{
          this.saveNewItemRegistration();
        });
      return;
    }

    //console.log("Saving user data");
    toast("Felhasználói adatok mentése ...", {type:'info'});
    let url = config.API_URL + '/User/signup.php';
    axios({
      method: 'post',
      url: url,
      //headers: { 'content-type': 'application/json' },
      data: JSON.stringify(this.state.userData)
    })
    .then(result => {
      //console.log("result", result);
      if(result.data.status === true){
        //toast("Felhasználói adatok mentve");
        //console.log("new user:" + result.data.id);
        this.setState({itemRegistrationData: {...this.state.itemRegistrationData, user_id: result.data.id}},
          ()=>{
            this.saveNewItemRegistration();
          });
      }
      else{
          alert("error: " + result.data.message);
      } 
    })
    .catch(error => alert(error.message));
  }

  saveNewItemRegistration = () => {
    toast("Kísérlet regisztráció mentése ...", {type:'info'});
    let url = config.API_URL + '/Item/register.php';
    //console.log("calling url:" + url);
    //console.log("JSON.stringify(this.state.item):", JSON.stringify(this.state.itemRegistrationData));
    let formDataObject = this.createFormData();
    
    axios({
        method: 'post',
        url: url,
        //headers: { 'content-type': 'application/json' },
        data: formDataObject
      })
      .then(result => {
        //console.log("result", result);
        if(result.data.status === true){
          //toast("Sikeres regisztráció");
          /*localStorage.setItem('userData', 
            JSON.stringify({...this.state.userData,
              id:this.state.itemRegistrationData.user_id,
              password:"", password2:""}
          ));*/

          login(this.state.userData.email, this.state.userData.password).then((responseJson) => {
            if(responseJson ){   
              this.props.setLogin();
              //console.log("redirect to" + this.state.pickedItem.id);
              this.props.history.push('/sikeresregisztracio?termek=' + this.state.pickedItem.id);
              //this.setState({actPhase: 5});
            } 
          });
        }
        else{
            alert("error: " + result.data.message);
        } 
      })
      .catch(error => alert(error.message));
  }

  
  createFormData = () => {
    const formDataObject = new FormData();
    //formDataObject.append('token', getUserToken());
    formDataObject.append('data', JSON.stringify(this.state.itemRegistrationData));
    if(this.state.itemRegistrationData.file1) formDataObject.append('file1', this.state.itemRegistrationData.file1, this.state.itemRegistrationData.file1.name);
    if(this.state.itemRegistrationData.file2) formDataObject.append('file2', this.state.itemRegistrationData.file2, this.state.itemRegistrationData.file2.name);
    if(this.state.itemRegistrationData.file3) formDataObject.append('file3', this.state.itemRegistrationData.file3, this.state.itemRegistrationData.file3.name);

    return formDataObject;
};

  render() { 
    return ( 
      <div style={{paddingBottom:30}}>
        <div className="row" style={{width:'95%', margin:'auto'}}>
          {this.state.actPhase < 5 && <Phases actPhase={this.state.actPhase}></Phases>}
        </div>
        <div className="row" style={{width:'100%', margin:'auto'}}>
          {this.state.actPhase === 1 && 
            <UserData handleSubmitClick={(values) => this.handleSubmitClick(values)}
              fullRegistration={true} 
              userData={(this.state.userData ?? null)} isModification={false}></UserData>}
          {this.state.actPhase === 2 && 
            <Regulations handleSubmitClick={() => this.handleSubmitClick2()} 
                  handleBackClick={() => this.handleBackClick2()}></Regulations>}
          {this.state.actPhase === 3 && 
            <ItemPicker handleSubmitClick={(pickedItem) => this.handleSubmitClick3(pickedItem)}
              handleBackClick={() => this.handleBackClick3()}></ItemPicker>}
          {this.state.actPhase === 4 && 
            <ItemRegistration handleSubmitClick={(itemRegistrationData) => this.handleSubmitClick4(itemRegistrationData)}
                handleBackClick={() => this.handleBackClick4()} 
                fullRegistration={true} 
                itemId={this.state.pickedItem.id}
                pickedItem={this.state.pickedItem}></ItemRegistration>}
          {this.state.actPhase === 5 && 
            <SuccessfulReg history={this.props.history} email={this.state.userData.email}></SuccessfulReg>}
                                              
        </div>
        <ToastContainer />
      </div> 
    );
  }
}
 
export default Registration;